import { pdf } from "@react-pdf/renderer";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../../../backend/firebaseconfig";
import getAllAdvisers from "../../../../context/HelperFunctions/getAllAdvisers"; // Your version
import DCCReport from "../Report/dccReport";


const generateDCCForAllAdvisers = async () => {

    const advisers = await getAllAdvisers();
    const debts = [
      { creditor: "Creditor A", balance: 5000, interestRate: 12.5, monthlyPayment: 150 },
        { creditor: "Creditor B", balance: 3000, interestRate: 10.0, monthlyPayment: 100 },
        { creditor: "Creditor C", balance: 2000, interestRate: 8.5, monthlyPayment: 80 },
    ];
    const loanAmount = 10000;
    const initialApr = 7.5;
    const svrApr = 5.0;
    const initialYears = 1;
    const initialMonths = 0;
    const termYears = 5;
    const termMonths = 0;
    const feeMode = "Fixed";
  const feeValue = 100;

  const totals = {
    weightedApr: 6.5,
    nExisting: 3,
    months: 60,
    fee: 100,
    totalMonthly: 330,
    monthlyPayInitial: 350,
    monthlyPayReversion: 360,
    monthlyPayNew: 340,
    totalPaymentsExisting: 20000,
    totalInterestExisting: 5000,
    warnNeverPaysOff: false,
    totalInterestNew: 3000,
    totalPaymentsNew: 18000,
  };
  const reportNarrative =
    "This is a sample narrative for the debt consolidation report.";

  for (const adviser of advisers) {
    const tradingName = adviser.brandName || "";

    let logo = "";
    try {
      const logoRef = ref(storage, `Logos/${tradingName}.jpg`);
      logo = await getDownloadURL(logoRef);
    } catch {
      logo = "";
    }

    const blob = await pdf(
      <DCCReport
        tradingName={adviser.brandName}
        logo={logo}
        primaryColor={adviser.primaryColor || "081e56"}
        regulatoryText={adviser.regulatoryText || ""}
        userEmail={adviser.email || ""}
        customerName={"Test Client"}
        adviserName={adviser.email}
        debts={debts}
        loanAmount={loanAmount === "" ? 0 : Number(loanAmount)}
        initialApr={initialApr === "" ? 0 : Number(initialApr)}
        svrApr={svrApr === "" ? 0 : Number(svrApr)}
        initialYears={initialYears === "" ? 0 : Number(initialYears)}
        initialMonths={initialMonths === "" ? 0 : Number(initialMonths)}
        termYears={termYears === "" ? 0 : Number(termYears)}
        termMonths={termMonths === "" ? 0 : Number(termMonths)}
        feeMode={feeMode}
        feeValue={feeValue === "" ? 0 : Number(feeValue)}
        totals={totals}
        narrative={reportNarrative}
        initialMonthlyOverride={1132}
        reversionMonthlyOverride={1231}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${adviser.email} - ${tradingName}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
    // }
  }
};

export default generateDCCForAllAdvisers;
